import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { s as styleInject } from './style-inject.es-4a6aca40.js';
import { Qiniu } from 'sunzi-utils';

var css_248z$3 = ".sunzi_components__size-12Vf0 {\n  padding: 0 10px;\n}\n.sunzi_components__size-12Vf0.sunzi_components__active-2pXbU .sunzi_components__content-1p2VK .sunzi_components__svg-wrapper-2g5y2 {\n  background-color: var(--sunzi-theme-color-o2);\n  border: 2px solid var(--sunzi-theme-color);\n}\n.sunzi_components__size-12Vf0.sunzi_components__active-2pXbU .sunzi_components__content-1p2VK .sunzi_components__svg-wrapper-2g5y2 svg {\n  stroke: var(--sunzi-theme-color);\n}\n.sunzi_components__size-12Vf0.sunzi_components__active-2pXbU .sunzi_components__title-2uSie {\n  color: var(--sunzi-theme-color);\n}\n.sunzi_components__size-12Vf0 .sunzi_components__content-1p2VK {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 100px;\n  overflow: hidden;\n}\n.sunzi_components__size-12Vf0 .sunzi_components__content-1p2VK .sunzi_components__svg-wrapper-2g5y2 {\n  position: relative;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 4px;\n  overflow: hidden;\n  background-color: rgba(81, 81, 81, 0.2);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.sunzi_components__size-12Vf0 .sunzi_components__content-1p2VK .sunzi_components__svg-wrapper-2g5y2 svg {\n  height: 100%;\n  stroke: #999;\n  stroke-width: 1%;\n}\n.sunzi_components__size-12Vf0 .sunzi_components__title-2uSie {\n  padding-top: 8px;\n  color: #000;\n  font-weight: 700;\n  font-size: 12px;\n  text-align: center;\n}\n";
var styles$3 = {"size":"sunzi_components__size-12Vf0","active":"sunzi_components__active-2pXbU","content":"sunzi_components__content-1p2VK","svgWrapper":"sunzi_components__svg-wrapper-2g5y2","title":"sunzi_components__title-2uSie"};
styleInject(css_248z$3);

var VariantSize = function (_a) {
  var _b;

  var className = _a.className,
      title = _a.title,
      active = _a.active,
      width = _a.width,
      height = _a.height,
      _c = _a.maxHeight,
      maxHeight = _c === void 0 ? height : _c,
      onClick = _a.onClick;
  return React.createElement("div", {
    className: classnames(styles$3.size, (_b = {}, _b[styles$3.active] = active, _b), className),
    onClick: onClick
  }, React.createElement("div", {
    className: styles$3.content
  }, React.createElement("div", {
    className: styles$3.svgWrapper,
    style: {
      height: height / maxHeight * 100 + "%"
    }
  }, React.createElement("svg", {
    viewBox: "0 0 " + width + " " + height
  }, React.createElement("line", {
    x1: 0,
    y1: height,
    x2: width,
    y2: 0
  }), React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: width,
    y2: height
  })))), title && React.createElement("div", {
    className: styles$3.title
  }, title));
};

var css_248z$2 = ".sunzi_components__image-2Y7wl {\n  padding: 0 10px;\n}\n.sunzi_components__image-2Y7wl.sunzi_components__active-14zhN .sunzi_components__content-1kjck::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border: 2px solid var(--sunzi-theme-color);\n  content: '';\n}\n.sunzi_components__image-2Y7wl.sunzi_components__active-14zhN .sunzi_components__content-1kjck .sunzi_components__corner-wrapper-2rwBg {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.sunzi_components__image-2Y7wl .sunzi_components__content-1kjck {\n  position: relative;\n  width: 58px;\n  height: 86px;\n  margin: 0 auto;\n  background-color: rgba(81, 81, 81, 0.2);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  cursor: pointer;\n}\n.sunzi_components__image-2Y7wl .sunzi_components__content-1kjck .sunzi_components__corner-wrapper-2rwBg {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: none;\n  width: 20px;\n  height: 20px;\n}\n.sunzi_components__image-2Y7wl .sunzi_components__content-1kjck .sunzi_components__corner-wrapper-2rwBg svg {\n  fill: var(--sunzi-theme-color);\n}\n.sunzi_components__image-2Y7wl .sunzi_components__title-iiyJh {\n  padding-top: 8px;\n  color: #000;\n  font-weight: 700;\n  font-size: 12px;\n  text-align: center;\n}\n";
var styles$2 = {"image":"sunzi_components__image-2Y7wl","active":"sunzi_components__active-14zhN","content":"sunzi_components__content-1kjck","cornerWrapper":"sunzi_components__corner-wrapper-2rwBg","title":"sunzi_components__title-iiyJh"};
styleInject(css_248z$2);

var VariantImage = function (_a) {
  var _b;

  var className = _a.className,
      contentClassName = _a.contentClassName,
      title = _a.title,
      image = _a.image,
      active = _a.active,
      onClick = _a.onClick;
  return React.createElement("div", {
    className: classnames(styles$2.image, (_b = {}, _b[styles$2.active] = active, _b), className),
    onClick: onClick
  }, React.createElement("div", {
    className: classnames(styles$2.content, contentClassName),
    style: {
      backgroundImage: "url(" + Qiniu.thumbnail(image, {
        height: 160
      }) + ")"
    }
  }, React.createElement("div", {
    className: styles$2.cornerWrapper
  }, React.createElement("svg", {
    viewBox: "0 0 21 21"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M0,0 L21,0 L21,20.998 L20.7617344,21 C9.41116722,21 0.188006262,11.7869603 0.0028378811,0.350774341 L0,0 L0,0 Z"
  }), React.createElement("g", {
    transform: "translate(5.000000, 0.000000)"
  }, React.createElement("path", {
    d: "M10.4,1.06666667 C10.8158379,1.06666667 11.1575726,1.38394031 11.1963378,1.78962133 L11.2,1.86666667 L11.2,10.9333333 C11.2,11.3491713 10.8827264,11.690906 10.4770453,11.7296712 L10.4,11.7333333 L5.6,11.7333333 C5.1581722,11.7333333 4.8,11.3751611 4.8,10.9333333 C4.8,10.5174954 5.11727364,10.1757607 5.52295466,10.1369955 L5.6,10.1333333 L9.59986099,10.1331711 L9.6,1.86666667 C9.6,1.45082874 9.91727364,1.10909404 10.3229547,1.07032884 L10.4,1.06666667 Z",
    fill: "#fff",
    "fill-rule": "nonzero",
    transform: "translate(8.000000, 6.400000) rotate(-315.000000) translate(-8.000000, -6.400000) "
  })))))), title && React.createElement("div", {
    className: styles$2.title
  }, title));
};

var css_248z$1 = ".sunzi_components__tag-gswxe {\n  padding: 0 10px;\n}\n.sunzi_components__tag-gswxe.sunzi_components__active-2I7t9 .sunzi_components__content-1Xuer {\n  color: var(--sunzi-theme-color);\n  background-color: var(--sunzi-theme-color-o2);\n}\n.sunzi_components__tag-gswxe.sunzi_components__active-2I7t9 .sunzi_components__content-1Xuer::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border: 2px solid var(--sunzi-theme-color);\n  border-radius: 4px;\n  content: '';\n}\n.sunzi_components__tag-gswxe .sunzi_components__content-1Xuer {\n  position: relative;\n  padding: 10px 12px;\n  color: #333;\n  font-size: 12px;\n  background-color: rgba(81, 81, 81, 0.2);\n  border-radius: 4px;\n}\n";
var styles$1 = {"tag":"sunzi_components__tag-gswxe","active":"sunzi_components__active-2I7t9","content":"sunzi_components__content-1Xuer"};
styleInject(css_248z$1);

var VariantTag = function (_a) {
  var _b;

  var className = _a.className,
      title = _a.title,
      active = _a.active,
      onClick = _a.onClick;
  return React.createElement("div", {
    className: classnames(styles$1.tag, (_b = {}, _b[styles$1.active] = active, _b), className),
    onClick: onClick
  }, React.createElement("div", {
    className: styles$1.content
  }, title));
};

var css_248z = ".sunzi_components__variant-3aBtE {\n  padding: 15px 0 25px 0;\n}\n.sunzi_components__variant-3aBtE .sunzi_components__title-3Ou7B {\n  padding: 0 0 15px 16px;\n  color: #000;\n  font-weight: 700;\n  font-size: 16px;\n  text-transform: uppercase;\n}\n.sunzi_components__variant-3aBtE .sunzi_components__content-2ggy- {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n";
var styles = {"variant":"sunzi_components__variant-3aBtE","title":"sunzi_components__title-3Ou7B","content":"sunzi_components__content-2ggy-"};
styleInject(css_248z);

var InternalVariant = function (_a) {
  var className = _a.className,
      title = _a.title,
      contentStyle = _a.contentStyle,
      children = _a.children;
  return React.createElement("div", {
    className: classnames(styles.variant, className)
  }, React.createElement("div", {
    className: styles.title
  }, title, ":"), React.createElement("div", {
    className: classnames(styles.content, 'variant-content'),
    style: contentStyle
  }, children));
};

var VariantRef = forwardRef(InternalVariant);
var Variant = VariantRef;
Variant.Size = VariantSize;
Variant.Image = VariantImage;
Variant.Tag = VariantTag;

export default Variant;
